import {FormatterBasic} from "./Core/FormatterBasic";
import {DateFormat} from "./Utils/DateFormat";

export class DateTimeFormatter extends FormatterBasic {
    Format(): string {
        return this.GetValue('Value');

    }

}